import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { useFeatureEnabled, useBrandUrl } from "@/hooks";
import { CALL_TRACKING_PATH } from "@/constants/api";
import { fetchWithTimeout } from "@/utils";
export const CallTrackingContext = createContext(null);
export const CallTrackingProvider = ({ children }) => {
    const isCallTrackingEnabled = useFeatureEnabled("callTracking");
    const callTrackingUrl = useBrandUrl({ endpoint: CALL_TRACKING_PATH });
    const [callTrackingData, setCallTrackingData] = useState({
        numberMappings: [],
    });
    const [isCallTrackingRequestDone, setIsCallTrackingRequestDone] = useState(false);
    useEffect(() => {
        setIsCallTrackingRequestDone(!isCallTrackingEnabled);
    }, [isCallTrackingEnabled]);
    const fetchCallTrackingData = useCallback(async (options) => {
        if (!callTrackingUrl) {
            console.warn("fetchData: URL is empty.");
        }
        try {
            const response = await fetchWithTimeout(callTrackingUrl, options, 3000);
            if (!response.ok) {
                console.error(`fetchData: Failed to fetch, status: ${response.status}`);
            }
            const fetchedData = await response.json();
            const data = await (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.data);
            setCallTrackingData(data);
        }
        catch (error) {
            console.error("fetchData: An error occurred while fetching.", error);
        }
        setIsCallTrackingRequestDone(true);
    }, [callTrackingUrl]);
    const contextValue = useMemo(() => ({
        numberMappings: callTrackingData === null || callTrackingData === void 0 ? void 0 : callTrackingData.numberMappings,
        fetchCallTrackingData,
        isCallTrackingRequestDone,
    }), [callTrackingData, fetchCallTrackingData, isCallTrackingRequestDone]);
    return (_jsx(CallTrackingContext.Provider, { value: contextValue, children: children }));
};
